import N8nSendStopButton from './N8nSendStopButton.vue';

export type { N8nSendStopButtonProps } from './N8nSendStopButton.vue';

export default N8nSendStopButton;
